import Flow from './flow';
import {invariant, log, flowToObservable} from './utils';

export default class Hub {
  // constructor
  constructor(options={}) {
    // Rx Refrence
    this.Observable = options.Observable;

    invariant(
      this.Observable,
      `gent-hub error ~ options.Observable not set.`
    );

    let beforeMiddlewares = options.beforeMiddlewares || [];
    let afterMiddlewares = options.afterMiddlewares || [];

    // store pipes, middlewares
    this._pipes = {};
    this._middlewares = {
      before: beforeMiddlewares,
      after: afterMiddlewares,
    };

    // _combinedMiddleware
    this._combinedMiddleware = this._combinedMiddleware.bind(this);
  }

  // from source to Observable
  from(arg) {
    arg = flowToObservable(arg);
    
    return this.Observable.from(arg);
  }

  // start a flow
  flow(arg) {
    arg = flowToObservable(arg);

    let flow = new Flow({
      Observable: this.Observable,
      hub: this
    });

    return flow.from(arg);
  }

  // start a flow from multi source
  flowAll(args=[]) {
    let observable;

    args.forEach((item, index) => {
      item = flowToObservable(item);

      if (index == 0) {
        observable = this.Observable.from(item)
          .map(data => [data]);
      } else {
        let next = this.Observable.from(item);
        observable = observable
          .combineLatest(next, (rst, cur) => {
            let arr = rst.slice();
            arr.push(cur);
            return arr;
          });
      }
    });

    return this.flow(observable);
  }

  // get pipe
  getPipe(name) {
    invariant(
      typeof this._pipes[name] === 'function',
      `gent-hub error ~ pipe <${name}> is not exists in this hub!`
    );
    return this._pipes[name];
  }

  // add pipe
  addPipe(name, pipe) {
    let fn = (data) => {
      return this.Observable.from(pipe(data));
    };
    this._pipes[name] = (data) => {
      return this.Observable.from([data])
        .concatMap(this._combinedMiddleware('before', name))
        .concatMap(fn)
        .concatMap(this._combinedMiddleware('after', name));
    }
  }

  // add pipes
  addPipes(scope, pipes) {
    Object.keys(pipes).forEach(key => {
      let pipe = pipes[key];
      let pipeName = scope + '.' + key;
      this.addPipe(pipeName, pipe);
    });
  }

  // commine middlewares
  _combinedMiddleware(type, pipeName) {
    let self = this;

    return (data) => {
      let observable = self.Observable.from([data]);

      self._middlewares[type].forEach(middleware => {
        let fn = (payload) => {
          let opts = {pipeName, type, hub: self};
          return self.Observable.from(middleware(payload, opts));
        };
        observable = observable.concatMap(fn);
      });
      
      return observable;
    }
  }

  // add middleware
  addMiddleware(type, middleware) {
    this._middlewares[type].push(middleware);
  }

  // remove middleware from hub
  removeMiddleware(type, middleware) {
    let middlewares = this._middlewares[type] || [];
    let index = middlewares.indexOf(middleware);
    if (index != -1) middlewares.splice(index, 1);
  }
}
